import { render, staticRenderFns } from "./firstData.vue?vue&type=template&id=4e9a0b14&scoped=true&"
import script from "./firstData.vue?vue&type=script&lang=js&"
export * from "./firstData.vue?vue&type=script&lang=js&"
import style0 from "./firstData.vue?vue&type=style&index=0&id=4e9a0b14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!///node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9a0b14",
  null
  
)

export default component.exports